import { BaseEntity } from ".";
import { IGet_corporations_corporation_id_industry_jobs_200_ok } from "../service/esiclient";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedCorporationEntity } from "./CorporationEntityCache";
import { getCachedStationEntity } from "./StationEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";
import moment from "moment";

export class CorporationIndustryJobEntity extends BaseEntity {
  private _corporation_id: number;
  constructor(id: number, props: any, corporation_id: number, character_id: number) {
    super(id, props);
    this._corporation_id = corporation_id;
    this._character_id = character_id;
    this._dataTypeName = "Corporation Industry Job";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    //const id = this._id;
    const props: Partial<IGet_corporations_corporation_id_industry_jobs_200_ok> = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      /*
      if (props.activity_id) {
        //needs ramActivities.yaml to resolve
      }
      */
      const corpEntity = await getCachedCorporationEntity(this._corporation_id);
      if (corpEntity !== null) {
        entity.properties["owner"] = await corpEntity.toJson();
      }
      if (props.completed_date) {
        const date = moment(props.completed_date);
        entity.properties["completed_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.end_date) {
        const end_date = moment(props.end_date);
        entity.properties["end_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: end_date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.pause_date) {
        const pause_date = moment(props.pause_date);
        entity.properties["pause_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: pause_date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.start_date) {
        const start_date = moment(props.start_date);
        entity.properties["start_date"] = {
          type: Excel.CellValueType.formattedNumber,
          basicValue: start_date.unix() / 86400 + 25569,
          numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
        };
      }
      if (props.installer_id) {
        const installerEntity = await getCachedCharacterEntity(props.installer_id);
        if (installerEntity !== null) {
          entity.properties["installer"] = await installerEntity.toJson();
          delete entity.properties["installer_id"];
        }
      }
      if (props.completed_character_id) {
        const installerEntity = await getCachedCharacterEntity(props.completed_character_id);
        if (installerEntity !== null) {
          entity.properties["completed_character"] = await installerEntity.toJson();
          delete entity.properties["completed_character_id"];
        }
      }
      if (props.output_location_id) {
        const stationEntity = await getCachedStationEntity(props.output_location_id);
        if (stationEntity !== null) {
          entity.properties["output_location"] = await stationEntity.toJson(true);
          delete entity.properties["output_location_id"];
        }
      }
      if (props.location_id) {
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
          delete entity.properties["location_id"];
        }
      }
      if (props.facility_id) {
        const facilityStationEntity = await getCachedStationEntity(props.facility_id);
        if (facilityStationEntity !== null) {
          entity.properties["facility"] = await facilityStationEntity.toJson(true);
          delete entity.properties["facility_id"];
        }
      }
      if (props.blueprint_location_id) {
        //this can also be an asset container or a corporation facility
        const blueprintStationEntity = await getCachedStationEntity(props.blueprint_location_id);
        if (blueprintStationEntity !== null) {
          entity.properties["blueprint_location"] = await blueprintStationEntity.toJson(true);
          delete entity.properties["blueprint_location_id"];
        }
      }
      // - Type properties
      if (Object.prototype.hasOwnProperty.call(props, "blueprint_type_id") && props.blueprint_type_id) {
        const blueprintTypeEntity = await getCachedTypeEntity(props["blueprint_type_id"]);
        if (blueprintTypeEntity !== null) {
          // - Name
          // The blueprint can be accessed by calling character blueprints and getting the ids of the them. Not implemented
          const status = props.status;
          entity.properties["name"] = {
            type: Excel.CellValueType.string,
            basicValue: blueprintTypeEntity.props["name"],
          };
          entity.text = blueprintTypeEntity.props["name"] + " (" + status + ")";
          // - Base Price
          if (Object.prototype.hasOwnProperty.call(blueprintTypeEntity.props, "basePrice")) {
            entity.properties["basePrice"] = {
              type: Excel.CellValueType.formattedNumber,
              basicValue: blueprintTypeEntity.props.basePrice === "None" ? 0 : blueprintTypeEntity.props.basePrice,
              numberFormat: "##0",
              propertyMetadata: {
                sublabel: "ISK",
              },
            };
          }
          //delete entity.properties["blueprint_type_id"];
        }
      }
      if (Object.prototype.hasOwnProperty.call(props, "product_type_id") && props.product_type_id) {
        const productType = await getCachedTypeEntity(props.product_type_id);
        if (productType !== null) {
          delete entity.properties["product_type_id"];
          entity.properties["product_type"] = await productType.toJson();
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };
    return entity;
  }
}
